<template>
  <div v-if="site">
    <c-row class="mb-3">
      <c-col sm="12" md="12">
        <!--        <CCard>-->
        <!--          <CCardBody>-->
        <!--            <CRow>-->
        <!--              <CCol sm="12">-->
        <!--                <h1 class="h4" v-html="site.name"></h1>-->
        <!--              </CCol>-->
        <!--            </CRow>-->
        <!--          </CCardBody>-->
        <!--        </CCard>-->

        <c-tabs class="tab-set-1">
          <c-tab title="Plugins" active>
            <template slot="title">
              Details
            </template>

            <!--            <h1 class="h4" v-html="site.name"></h1>-->

            <c-row>
              <c-col sm="12" md="4">
                <!--                <CInput-->
                <!--                    label="Site name"-->
                <!--                    v-model="data.body.siteName"-->
                <!--                    class="input"-->
                <!--                    type="text"-->
                <!--                    placeholder="Site name"-->
                <!--                />-->
                <!--                <CInput-->
                <!--                    label="Site URL"-->
                <!--                    v-model="data.body.siteUrl"-->
                <!--                    class="input"-->
                <!--                    type="text"-->
                <!--                    placeholder="Site URL"-->
                <!--                />-->

                <!--                <CButtonGroup>-->
                <!--                  <CButton-->
                <!--                      color="primary"-->
                <!--                      @click="save"-->
                <!--                      :disabled="!enableSave"-->
                <!--                      :class="{'is-loading': isSaving}">Save-->
                <!--                  </CButton>-->
                <!--                  <CButton color="secondary" v-if="showCancelButton" @click="cancelEdit">Cancel-->
                <!--                  </CButton>-->
                <!--                </CButtonGroup>-->

                <edit-details :site="site" />
              </c-col>
            </c-row>
          </c-tab>
          <c-tab title="Themes">
            <template slot="title">
              Authentication
            </template>
          </c-tab>
        </c-tabs>
      </c-col>
    </c-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { freeSet } from '@coreui/icons';
import _ from 'lodash';
import io from 'socket.io-client';
import { iconsSet } from '../../assets/icons/icons';
import Pill from '../components/Pill';
import ConfirmModal from '@/views/components/ConfirmModal';
import { buildEndpoint } from '../../libs/buildEndPoint';

import EditDetails from '@/views/components/site/edit-details';

const socket = io(buildEndpoint(''));

export default {
  name: 'SiteDetails',

  components: {
    Pill,
    ConfirmModal,
    EditDetails,
  },

  data() {
    return {
      iconsSet,
      site: null,
      error: null,
      showCancelButton: false,
      data: {
        body: {
          siteName: null,
          siteUrl: null,
        },
      },
      freeSet,
    };
  },

  computed: {
    themeUpdateCount() {
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      if (this.parsedSiteData && this.parsedSiteData.installedThemes && this.parsedSiteData.installedThemes.length) {
        const updates = this.parsedSiteData.installedThemes.map((theme) => (theme.updateFound ? 1 : 0));
        return updates.reduce(reducer);
      }
    },
  },

  mounted() {
    this.siteId = this.$route.params.siteId;
    this.get();
  },

  updated() {},

  methods: {
    get() {
      this.$http
        .get(buildEndpoint('site/get/') + this.siteId)
        .then((response) => {
          this.error = null;
          if (response.data.success) {
            this.site = response.data.data.site;
            this.data.body = {
              siteName: this.site.name,
              siteUrl: this.site.siteAddress,
            };
          } else {
            this.error = 'Error getting site data';
          }
        })
        .catch((error) => {
          this.error = error.message;
        });
    },

    save() {
      // this.$validate()
      //     .then((success) => {
      //       if (success) {
      //         this.isSaving = true
      //         this.error = null
      //
      //         let data = {
      //           id: this.siteId,
      //           name: this.data.body.name,
      //           siteAddress: this.data.body.siteAddress
      //         }
      //
      //         this.$http.post(buildEndpoint('site/update'), data).then((response) => {
      //           this.isSaving = false
      //           if (response.data.success) {
      //             this.$router.push({name: 'detailsSite', params: {siteId: this.siteId}})
      //             // all good
      //           } else {
      //             this.error = 'Error saving site data'
      //           }
      //         }).catch((error) => {
      //           this.isSaving = false
      //           this.error = error
      //         })
      //       } else {
      //         fieldHighlights.highlight(this.validation, this.requiredFields)
      //       }
      //     })
    },
  },
};
</script>

<style lang="scss" scoped="">
.plugin-list {
  tr {
    &.plugin-blocked {
      /*background-color: lighten(#ffdd57, 20%);*/
      background-color: rgba(217, 171, 72, 0.2);
    }
  }
}
table {
  font-size: 12px;
  thead {
    tr {
      th {
        &.has-text-centered {
          text-align: center !important;
        }
      }
    }
  }

  tbody {
    tr {
      height: 45px;

      &.is-loading {
        background: lighten(#00d1b2, 50%);
      }
    }
  }
}

.notes {
  .read-only {
    height: 75px;
    overflow: auto;
    border: 1px solid silver;
    padding: 5px;
    cursor: pointer;
  }
  .add-notes {
    width: 100%;
    display: block;
    text-align: center;
    text-decoration: underline;
    margin-top: 20px;
  }
}

.installed-themes {
  tbody {
    tr {
      height: 47px;

      &.active {
        td {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
